<template>
  <button
    :class="[
      'btn',
      `btn-${outline ? 'outline-' : ''}${variant}`,
      size && `btn-${size}`,
      disabledState && 'disabled',
      iconOnly && 'btn-icon',
      isMarked && 'btn-marked',
      props.class,
    ]"
    :disabled="disabledState"
    :type="type"
  >
    <template v-if="loading">
      <span class="spinner-border spinner-border-sm" :class="slots.default && 'me-2'" aria-hidden="true" />
      <span class="visually-hidden" role="status">Loading...</span>
    </template>
    <template v-else-if="icon">
      <i :class="[`bx ${icon}`, iconPos === 'right' && 'order-1']" aria-hidden="true" />
    </template>
    <slot />
  </button>
</template>

<script setup>
import { computed, useSlots } from 'vue'

import { BUTTON_VARIANTS, SIZES } from '@shared/constants/bootstrap'

/* eslint-disable vue/require-default-prop */
const props = defineProps({
  variant: {
    type: String,
    required: false,
    default: 'primary',
    validator: (val) => BUTTON_VARIANTS.includes(val),
  },
  size: {
    type: String,
    required: false,
    validator: (val) => SIZES.includes(val),
  },
  icon: { type: String, required: false },
  iconPos: {
    type: String,
    required: false,
    validator: (val) => ['left', 'right'].includes(val),
  },
  isMarked: { type: Boolean, required: false },
  outline: { type: Boolean, required: false },
  disabled: { type: Boolean, required: false },
  loading: { type: Boolean, required: false },
  type: { type: null, required: false, default: 'button' },
  class: { type: null, required: false },
})

const slots = useSlots()

const disabledState = computed(() => props.disabled || props.loading)
const iconOnly = computed(() => !!(!slots.default && props.icon))
</script>
